import styled from 'styled-components';
import {SuspenseLoader} from 'styled/common';

export const View = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  padding: 40px 24px;
  border-radius: 16px;
  background: ${props => props.theme.colors.branding.boxesModals};

  max-width: 605px;
`;

export const Title = styled.div`
  font-size: 20px;
  line-height: 24px;
  font-weight: 500;
  color: ${props =>
    props.theme.hasTemplate ? props.theme.colors.branding.fontPrimary : '#152946'};
`;

export const HeaderInfo = styled.div`
  color: ${({theme}) =>
    theme.hasTemplate ? theme.colors.branding.fontSecondary : '#777e91'};
`;

export const InfoTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ul {
    margin: 0;
    padding-left: 18px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }
`;

export const PhoneIcon = styled.img`
  user-select: none;
  width: 32px;
`;

export const Header = styled.div`
  display: flex;
  gap: 24px;

  align-items: start;

  ${PhoneIcon} {
    margin-top: 5px;
  }
`;

export const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Content = styled.div`
  display: flex;
  gap: 24px;
`;

export const ContentWrapper = styled.div`
  padding: 24px;

  border-radius: 12px;
  border: 2px solid rgba(0, 0, 0, 0.1);

  align-self: start;
`;

export const ListContentWrapper = styled(ContentWrapper)`
  padding: 16px;
  background-color: ${({theme}) => theme.colors.branding.backgroundMain};
  align-self: unset;
`;

export const QRCodeWrapper = styled.div`
  height: 128px;
  width: 128px;

  & svg {
    height: 128px;
    width: 128px;
  }
`;

export const StyledLoader = styled(SuspenseLoader)`
  padding-bottom: 0;
  align-self: center;
`;
